module.exports = __webpack_public_path__ + "img/emptystate.970ca801.svg";